import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
const Login = ({ handleLogin }) => {
  const navigate = useNavigate();
  const [userName, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
  
    // Set loading to true when the submission starts
    setLoading(true);
    const encodedPassword = btoa(password);
    
    try {
      const response = await axios.post(
        "https://service.khexports.in/api/User/Authenticate",
        { userName, password: encodedPassword }
      );
  
      const token = response.data.Token;
      const responses = response.data;
      console.log(responses);
  
      if (token) { 
        console.log(token);
        sessionStorage.setItem("tokens", token);
        sessionStorage.setItem("response", JSON.stringify(responses));
  
        // Navigate to another page
        navigate("/temp2");
      } else {
        setError("Invalid credentials"); 
      }
    } catch (err) {
      setError("Invalid credentials"); 
    } finally {
      // Reset loading state when the request is complete
      setLoading(false);
    }
  };
  
  
  if (loading) {
    return (
      <div className="flex space-x-2 justify-center items-center fixed top-0 left-0 w-full h-full bg-transparent z-50">
        <span className="sr-only">Loading...</span>
        <div className="h-8 w-8 bg-black rounded-full animate-bounce [animation-delay:-0.3s]"></div>
        <div className="h-8 w-8 bg-black rounded-full animate-bounce [animation-delay:-0.15s]"></div>
        <div className="h-8 w-8 bg-black rounded-full animate-bounce"></div>
      </div>
    );
  }

  return (
    <div className="min-h-full flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        {/* <h2 className="text-3xl font-extrabold text-gray-900 text-center mb-6">
          Login
        </h2> */}
        <div className="border bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10 m-4 mt-24">
          <form className="space-y-6" onSubmit={onSubmit}>
            <h1 className="text-red-500">{error}</h1>
            <div>
              <label
                htmlFor="email"
                className="text-left block text-sm font-medium text-gray-700"
              >
                Username:
              </label>
              <div className="mt-1">
                <input
                  id="email"
                  name="email"
                  type="text"
                  placeholder="Enter your username"
                  required
                  className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                  value={userName}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
            </div>

            <div>
              <label
                htmlFor="password"
                className="text-left block text-sm font-medium text-gray-700"
              >
                Password:
              </label>
              <div className="mt-1">
                <input
                  id="password"
                  name="password"
                  type="password"
                  placeholder="Enter your password"
                  required
                  className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
            </div>

            <div className="flex justify-between">
              <button
                type="submit"
                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                Login
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
